import { __decorate } from "tslib";
import { createEasyWebWorker } from 'easy-web-worker';
import { SingletonService } from '@trp-dms-digital-shared/ds-ui-library-common';
let FetchWorker = class FetchWorker {
    createGetFetchWorker() {
        return createEasyWebWorker(({ onMessage }) => {
            /**
             * Inside the worker we have to define an action when onMessage
             */
            onMessage(async (message) => {
                /**
                 * The payload includes whatever parameters are sent from the main thread
                 */
                const { payload } = message;
                await fetch(payload, {
                    method: 'GET',
                })
                    .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.text();
                })
                    .then((text) => {
                    message.resolve(text);
                })
                    .catch(() => {
                    message.resolve('');
                });
            });
        }, {
            maxWorkers: 1,
            keepAlive: false,
        });
    }
};
FetchWorker = __decorate([
    SingletonService
    /* istanbul ignore next */
], FetchWorker);
export { FetchWorker };
//# sourceMappingURL=fetch-worker.js.map